export default "__VITE_ASSET__1ZtaEee6__"